import * as m from "mithril";
import './ModalDialog.css';
import CustomSvgIcon, { CustomSvgIconType } from "./CustomSvgIcon";

export default function ModalDialog(): m.Component<{
    title? : string,    
    message? : string,
    iconType?: CustomSvgIconType,
    iconThemeClass?: string,
    shouldOpen: boolean,
    onClosed: () => void,
    actionItems?: {label: string, onclick: () => void}[]
}> {
    let dialogElem:HTMLDialogElement|null = null;
        
    return {        
        oncreate(vnode) {
            dialogElem = vnode.dom as HTMLDialogElement;
        },

        onbeforeupdate(vnode) {
            if(dialogElem) {
                if(dialogElem.open) {
                    if(vnode.attrs.shouldOpen == false) {
                        dialogElem.close();
                    } 
                } else {
                    if(vnode.attrs.shouldOpen) {
                        dialogElem.showModal();
                    }
                }
            }
        },

        /* onupdate(vnode) {
            //console.log(vnode.attrs);
        }, */

        view(vnode) {            
            return m("dialog", {
                class: "dialog-modal"
            },                
                [
                    m("div.card-header",{class:"pb-2 bg-white border-0"}, [       

                        (vnode.attrs.iconType != undefined) ?
                            m("span.mr-2",
                                m(CustomSvgIcon, {
                                    iconType: vnode.attrs.iconType,
                                    themeCssClass: vnode.attrs.iconThemeClass ? vnode.attrs.iconThemeClass : "svg-medium svg-warning"
                                }),
                            ) : null,

                        (vnode.attrs.title != null) ?
                            m("span.lead", { class: "font-weight-bold mb-3" }, vnode.attrs.title) : null,

                    ]),
                    m("div.card-body.pt-0", [       
                        (vnode.attrs.message != null)?
                        m("div", {class:"mb-1"}, vnode.attrs.message): null,
                        
                        vnode.children,
                    ]), 
                        (vnode.attrs.actionItems != null)? 
                        m("div.card-footer", {class: "text-right border-0 bg-white pt-0"},
                            vnode.attrs.actionItems.map(item => {
                                return m("button", {
                                    class:'btn btn-light text-primary mr-1',
                                    onclick: function(event) {
                                        item.onclick();
                                        //attrs.onClose();
                                    }
                                }, item.label)
                            })                        
                        ): null
                    
                ]
            )
        }
    };
}